import { theme } from '@prose-ui';

import { Ticker } from 'Blocks/Ticker';

const MembershipTicker = () => (
  <Ticker
    backgroundColor={theme.colors.tertiary[200]}
    content={['You look great today']}
    fontColor={theme.colors.primary[400]}
    showDash={false}
  />
);

export default MembershipTicker;
